<app-loading-overlay></app-loading-overlay>

@if (toast) {
  <app-toast [toast]="toast"></app-toast>
}

@if (toastService.toast$ | async; as toast) {
  <app-toast [toast]="toast"></app-toast>
}

<router-outlet></router-outlet>

<app-incoming-call-modal
  [caller]="callService.caller"
  [isVisible]="callService.showModal"
  [mode]="callService.mode"
  [elapsed]="callService.elapsed"
  [isAccepting]="callService.isAccepting"
  [isDeclining]="callService.isDeclining"
  (accept)="callService.acceptCall()"
  (decline)="callService.declineCall()"
  (cancel)="callService.cancelCall()"
  (end)="callService.endCall()">
</app-incoming-call-modal>
